<script setup lang="ts">
    import EventIcon from '../EventIcon.vue';
    import { computed } from 'vue';
    import { useRoute } from 'vue-router';

    const props = defineProps<{
        eventId: string;
    }>();

    const steps = [
        { routeName: 'EventEditorDetailsNameAndDescription', label: () => $Resources.EventNavDetailsGeneral },
        { routeName: 'EventEditorDetailsHero', label: () => $Resources.EventNavDetailsHero },
        { routeName: 'EventEditorDetailsContactPerson', label: () => $Resources.EventNavDetailsContactPerson },
        { routeName: 'EventEditorDetailsStartAndEnd', label: () => $Resources.EventNavDetailsStartAndEnd },
        { routeName: 'EventEditorDetailsRegistration', label: () => $Resources.EventNavDetailsRegistration },
        { routeName: 'EventEditorDetailsParticipantLimit', label: () => $Resources.EventNavDetailsParticipantLimit },
        { routeName: 'EventEditorDetailsLocation', label: () => $Resources.EventNavDetailsLocation },
        { routeName: 'EventEditorDetailsOrganizer', label: () => $Resources.EventNavDetailsOrganizer },
    ];

    const route = useRoute();
    const currentIndex = computed(() => steps.findIndex((step) => step.routeName === route.name));

    const prevStep = computed(() => (currentIndex.value > 0 ? steps[currentIndex.value - 1] : null));
    const nextStep = computed(() => (currentIndex.value >= 0 && currentIndex.value < steps.length - 1 ? steps[currentIndex.value + 1] : null));
</script>

<template>
    <nav class="event-details-nav form-group d-flex flex-wrap p-sm-t">
        <router-link v-if="prevStep" :to="{ name: prevStep.routeName, params: { eventId: props.eventId } }" class="btn btn-subtle btn-flex p-xs-l">
            <EventIcon icon="arrowBack" :size="16" />
            {{ prevStep.label() }}
        </router-link>

        <router-link v-if="nextStep" :to="{ name: nextStep.routeName, params: { eventId: props.eventId } }" class="btn btn-subtle btn-flex p-xs-r m-auto-l">
            {{ nextStep.label() }}
            <EventIcon icon="arrowForward" :size="16" />
        </router-link>
    </nav>
</template>
